import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/complain-policy/hero";
import PP from "../components/complain-policy/content";
import CTA from "../components/universal/cta";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";

function Index() {
  return (
    <div>
      <Helmet>
        <title>Complaints Policy | Same Day Smile Ilkley | Patient Care</title>
        <meta
          name="description"
          content="Learn about our complaints policy at Same Day Smile Ilkley. We are committed to resolving any concerns promptly and ensuring every patient receives exceptional care."
        />
        <link
          rel="canonical"
          href="https://www.samedaysmile-ilkley.com/complain-policy"
        />
      </Helmet>
      <Navbar />
      <Header />
      <PP />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;
